type SkeletonProps = {
  className?: string;
};

export function Skeleton({ className = "" }: SkeletonProps) {
  return <span className={`ms-skeleton ${className}`.trim()} aria-hidden="true" />;
}

export function PageFallback() {
  return (
    <div className="page-fallback" role="status" aria-live="polite" aria-label="页面加载中">
      <div className="page-fallback-bar" />
      <div className="page-fallback-hero">
        <Skeleton className="is-fill" />
      </div>
      <div className="page-fallback-grid">
        {Array.from({ length: 6 }, (_, index) => (
          <div className="page-fallback-card" key={index}>
            <span className="page-fallback-media">
              <Skeleton className="is-fill" />
            </span>
            <Skeleton className="is-title" />
            <Skeleton className="is-short" />
          </div>
        ))}
      </div>
    </div>
  );
}
